import React, { useMemo } from "react";
import { Users, Pill, PersonStanding, MoveUpRightIcon } from "lucide-react";
import Card from "../../../shared/components/Card";

const StatsGrid = ({ statistics }) => {
  const stats = useMemo(() => {
    return [
      {
        label: "OHC Staff",
        value: statistics.total_users,
        icon: Users,
        color: "bg-blue-500",
        subtext: `${statistics.active_users} present`,
      },
      {
        label: "Employees",
        value: statistics.total_patients,
        icon: PersonStanding,
        color: "bg-green-500",
        subtext: `${statistics.active_patients} visited today`,
      },
      {
        label: "Stock Count",
        value: statistics.total_medicines,
        icon: Pill,
        color: "bg-yellow-500",
        subtext: "Total inventory",
      },
      {
        label: "Visits Today",
        value: statistics.visits_today,
        icon: MoveUpRightIcon,
        color: "bg-purple-500",
        subtext: `${statistics.medicines_today} issued today`,
      },
    ];
  }, [statistics]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {stats.map((stat, index) => {
        const Icon = stat.icon;

        return (
          <Card key={index} className="hover:shadow-lg">
            <div className="flex items-center">
              <div className={`${stat.color} p-3 rounded-lg`}>
                <Icon className="h-6 w-6 text-white" />
              </div>

              <div className="ml-4">
                <p className="text-sm text-gray-600">{stat.label}</p>

                <p className="text-2xl font-semibold">{stat.value}</p>

                {/* <p className="text-xs text-gray-500">{stat.subtext}</p> */}
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export default React.memo(StatsGrid);